__turbopack_context__.v({
  "categorySection": "PromptTemplatesDialog-module__dsQA8q__categorySection",
  "categoryTitle": "PromptTemplatesDialog-module__dsQA8q__categoryTitle",
  "dialog": "PromptTemplatesDialog-module__dsQA8q__dialog",
  "dialogContent": "PromptTemplatesDialog-module__dsQA8q__dialogContent",
  "horizontalLine": "PromptTemplatesDialog-module__dsQA8q__horizontalLine",
  "noResultsText": "PromptTemplatesDialog-module__dsQA8q__noResultsText",
  "searchInput": "PromptTemplatesDialog-module__dsQA8q__searchInput",
  "selectButton": "PromptTemplatesDialog-module__dsQA8q__selectButton",
  "templateItem": "PromptTemplatesDialog-module__dsQA8q__templateItem",
  "templatesListContainer": "PromptTemplatesDialog-module__dsQA8q__templatesListContainer",
});
